import Icon from "./logo";
var CnLayoutAsidePrototype = {
  title: '侧边栏',
  componentName: 'CnLayoutAside',
  // category: '图表',
  icon: Icon,
  docUrl: '',
  isContainer: true,
  configure: [{
    name: 'isCnLayoutAside',
    title: 'CnLayoutAside',
    initialValue: true,
    display: 'none'
  }, {
    name: '_context',
    title: '上下文',
    initialValue: {
      type: 'JSExpression',
      value: 'this'
    },
    display: 'none'
  }, {
    type: 'group',
    title: {
      label: '样式'
    },
    extraProps: {
      display: 'accordion'
    },
    items: [{
      name: 'width',
      title: '宽度',
      display: 'none',
      defaultValue: 336,
      setter: 'NumberSetter'
    }]
  }]
};
// 原型配置请参考：https://lark.alipay.com/vision/docs/prototype

export { CnLayoutAsidePrototype };